<template>
  <v-container id="drivers" fluid tag="section">
    <div class="text-right">
      <v-btn
        color="cyan"
        v-if="showGrid"
        @click="showFilter = !showFilter"
        small
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        class="mr-0"
        small
        v-if="singlePage && !showGrid"
        @click="
          showGrid = !showGrid;
          driver_id = null;
        "
      >
        <v-icon v-if="showGrid">mdi-plus</v-icon>
        <v-icon v-if="!showGrid">mdi-grid</v-icon>
        {{ $i18n.t("All") }}
      </v-btn>
      <v-menu offset-y v-if="showGrid">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="!singlePage" :to="'/driver/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Add New")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="singlePage"
            @click="
              showGrid = !showGrid;
              driver_id = null;
            "
          >
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Add New")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showBulkModificationModal">
            <v-icon>mdi-refresh</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Bulk Modification")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showBulkUpload = true">
            <v-icon>mdi-cloud-upload</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Bulk Upload")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <z-confirm-button
              class="float-right list-item-btn"
              small
              text
              :loading="loading"
              :message="$i18n.t('Send Install App SMS to drivers ?')"
              @click="sendAppInstallSMS"
            >
              <v-icon>mdi-cellphone-information</v-icon>
              <span class="ms-3">{{ $i18n.t("Notify Install App") }}</span>
            </z-confirm-button>
          </v-list-item>
          <v-list-item>
            <z-confirm-button
              class="float-right list-item-btn"
              small
              text
              :loading="loading"
              :message="$i18n.t('Do you want to delete selected Drivers ?')"
              @click="deleteSelected"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
              <span class="ms-3">{{ $i18n.t("Delete Selected") }}</span>
            </z-confirm-button>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <driver-edit
      v-if="!showGrid"
      :driver_id="driver_id"
      :singlePage="singlePage"
      @select="select"
    />

    <v-dialog
      v-model="showBulkUpload"
      transition="dialog-top-transition"
      width="600"
    >
      <v-card>
        <v-toolbar dark color="primary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Bulk Upload") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="showBulkUpload = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-file-input
            chips
            :label="$i18n.t('Driver XLS File') + '*'"
            @change="handleXLSupload()"
            v-model="driverUploadFile"
          ></v-file-input>
          {{ $i18n.t("Upload Driver detail in xlsx file.") }}
          {{ $i18n.t("A Sample xlsx can be found") }}
          <a
            href="/xls/driversample.xlsx?v=JSVERSION"
            target="_blank"
            class="color-green"
            >{{ $i18n.t("here") }}</a
          >
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            class="mr-0"
            small
            dark
            @click="bulkUploadDriver"
            :loading="loading"
          >
            <v-icon>mdi-cloud-upload</v-icon>
            &nbsp;
            {{ $i18n.t("Upload") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center" v-if="showFilter && showGrid">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="filter.name"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-country-select
                isd
                clearable
                :label="$i18n.t('Country Code')"
                class="purple-input"
                v-model="filter.country"
              ></z-country-select>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Phone')"
                class="purple-input"
                v-model="filter.phone"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-vendor-select
                withSelf
                clearable
                class="purple-input"
                v-model="filter.vendor"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-zone-select
                clearable
                class="purple-input"
                v-model="filter.zone"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-checkbox
                class="purple-input"
                v-model="filter.appStatus"
                :label="$i18n.t('App Status')"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-checkbox
                class="purple-input"
                v-model="filter.powerSaver"
                :label="$i18n.t('Power Saver Mode on')"
              />
            </v-col>
            <v-row>
              <v-spacer />
              <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-0"
                      color="grey darken"
                      fab
                      text
                      small
                      @click="clear(1)"
                      style="margin-right: 10px !important"
                      v-on="on"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("Clear Filter") }}</span>
                </v-tooltip>
                <v-btn
                  color="success"
                  class="mr-3"
                  fab
                  small
                  dark
                  @click="search()"
                  :loading="loading"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <bulk-modification-driver
      :showDialog="showBulkUpdateDialog"
      :payload="payload"
      :refresh="refresh"
      @closeDialog="closeDialog"
    />

    <v-btn
      v-if="showGrid && grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-account-multiple"
      :title="$i18n.t('Employees')"
      class="px-5 py-3 small-icon"
      v-if="showGrid && grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                <v-checkbox
                  v-model="selectAll"
                  class="my-0"
                  style="height: 27px"
                />
              </th>
              <!-- <th class="text-left"></th> -->
              <th class="text-left">{{ $i18n.t("Name") }}</th>
              <th class="text-left">{{ $i18n.t("Phone") }}</th>
              <th class="text-left">{{ $i18n.t("Type") }}</th>
              <th class="text-left">{{ $i18n.t("Owner") }}</th>
              <th class="text-left">{{ $i18n.t("Zone") }}</th>
              <th class="text-left">{{ $i18n.t("Compliance") }}</th>
              <th class="text-left">{{ $i18n.t("Last Online") }}</th>
              <th class="text-left">{{ $i18n.t("On Duty") }}</th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <driver-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :selected="selectAll"
            :refresh="refresh"
            @select="select"
            :showSelectBtn="showSelectBtn"
            :singlePage="singlePage"
            @driverEdit="driverEdit"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import DriverRow from "@/views/driver/DriverRow.vue";
import BulkModificationDriver from "@/views/driver/BulkModificationDriver.vue";
import DriverEdit from "@/views/driver/DriverEdit.vue";

@Component({
  name: "Drivers",
  components: { DriverRow, BulkModificationDriver, DriverEdit },
  props: {
    singlePage: {
      default: false,
    },
    showGrid1: {
      default: true,
    },
    showSelectBtn: {
      default: false,
    },
  },
})
export default class Drivers extends Vue {
  showBulkUpdateDialog = false;
  showBulkUpload = false;
  selectAll = false;
  grid = { page: 0, rows: [] };
  url = "/api/drivers/data?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;
  selectedDrivers = [];
  payload = {};
  showGrid = true;
  driver_id = null;

  driverEdit(_id) {
    //This is used for single page application
    this.driver_id = _id;
    this.showGrid = false;
  }

  filter = {
    name: null,
    countryCode: null,
    phone: "",
    zone: "",
    vendor: "",
    appStatus: null,
    corp_accepted: null,
    powerSaver: null,
  };

  select(data) {
    this.$emit("select", data);
    this.showGrid = true;
    // this.clear();
  }

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  driverUploadFile = null;
  handleXLSupload(files) {
    if (files) {
      this.driverUploadFile = files[0];
    }
  }

  async bulkUploadDriver() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.isSet(this.driverUploadFile)) {
        formData.append("file", this.driverUploadFile);
      }
      const url = "/api/driver/uploadDrivers";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Uploaded Successfully");
      this.showPage(this.page);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async mounted() {
    this.showGrid = this.showGrid1;
    this.search();
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        for (let i = 0; i < grid.rows.length; i++) {
          grid.rows[i].selected = false;
        }
      }
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      name: null,
      countryCode: null,
      phone: "",
      vendor: null,
      zone: "",
      appStatus: null,
      corp_accepted: null,
      powerSaver: null,
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    if (this.filter.name) this.filterUrl += "&name=" + this.filter.name;
    if (this.filter.countryCode)
      this.filterUrl += "&countryCode=" + this.filter.countryCode;
    if (this.filter.phone) this.filterUrl += "&phone=" + this.filter.phone;
    if (this.filter.vendor) this.filterUrl += "&driverOf=" + this.filter.vendor;
    if (this.filter.onDuty) this.filterUrl += "&onDuty=trur";
    if (this.filter.powerSaver) this.filterUrl += "&powerSaver=true";
    if (this.filter.appStatus)
      this.filterUrl += "&appStatus=" + this.filter.appStatus;
    if (this.filter.corp_accepted)
      this.filterUrl += "&corp_accepted=" + this.filter.corp_accepted;
    if (this.filter.zone) this.filterUrl += "&zone_id=" + this.filter.zone;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteDriver(driver_id) {
    common.setLoading(true);
    try {
      await doGet("/api/driver/delete/" + driver_id);
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async sendAppInstallSMS() {
    common.setLoading(true);
    try {
      await doGet("/api/driver/install/app");
      common.showMessage("Sent Successfully");
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async deleteSelected() {
    common.setLoading(true);
    let ids = "";
    this.grid.rows.forEach(function (t) {
      if (t.selected) ids += t._id + ",";
    });
    if (!this.isSet(ids)) {
      common.setError("Select drivers to delete");
      common.setLoading(false);
      return;
    }
    try {
      await doPost("/api/driver/bulk/delete", { driver_ids: ids });
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async reload() {
    this.showPage(this.page);
  }

  closeDialog() {
    this.showBulkUpdateDialog = false;
    this.payload = {};
  }

  showBulkModificationModal() {
    const payload = {};

    let count = 0;
    let ids = "";
    this.grid.rows.forEach(function (t) {
      if (t.selected) {
        count++;
        ids += t._id + ",";
      }
    });
    if (count == 0) {
      common.setError("Please select driver(s).");
      return;
    }

    this.grid.rows.forEach(function (t) {
      if (t.selected) ids += t._id + ",";
    });

    payload.driver_ids = ids;

    this.payload = payload;
    this.showBulkUpdateDialog = true;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
